// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2MkIV","title":"title-13BP2","info":"info-1Fg8b","info__icon":"info__icon-1zl6B","info__text":"info__text-zJ2Zi","ticket":"ticket-6GIpo"};